import React from "react";
import styled  from "styled-components";
import portrait from './img/dominiquedevos.jpg';


const AboutDiv = styled.div`
    position: relative;
    padding-top: 60px;
    width: 100%;
    height: 500px;
    color: white;
    z-index: 1;


    h1{
      position: absolute;
      font-family: 'Clash Display', sans-serif;
      font-weight: 400;
      left: 10%;
      text-align: left;
      opacity: 1;
      font-size: 5.3vw;
    }

    h4{
      position: absolute;
      font-family: 'Clash Display', sans-serif;
      font-weight: 400;
      top: 30%;
      left: 10%;
      text-align: left;
      opacity: 1;
      font-size: 3.3vw;
    }

    p{
      padding-top: 100px;
      font-family: "Montserrat",sans-serif;
      font-weight: 300;
      font-size: 1.2rem;
      position: absolute;
      width: 35%;
      top: 30%;
      left:10%;
      height: 100%;
      text-align: left;
    }

    img{
      position: absolute;
      right: 20%;
      top: 50%;
      width: auto
      
    }

    @media only screen and (max-width: 1000px) {

    padding-top: 20px;
    width: 100%;
    height: 800px;

        h1{
            font-size: 7vw; 
        }


        p{
          padding-top: 5px;
          font-weight: 300;
          font-size: 1.2rem;
          position: absolute;
          width: 80%;
          top: 10%;
          left:10%;
          height: 100%;
          text-align: left;
          margin-bottom: 5px;
        }

        img{
            position: absolute;
            margin-left: auto;
            margin-right: auto;
            margin-top: 10px;
            width: auto;
            right: 22%;
        }
}
    `


function About() {
  return (
    <AboutDiv>
      <h1>Let me introduce myself</h1>
      <p>I am Dominique de Vos developer in soft and hardware. After my bachelor studies Creative Media and Game Technology I founded Fox Connect. 
        Where I make interactive products for companies and individuals. I love making things where physical objects can be controled with software. 
    
      </p>

        <img src={portrait} alt="Profiel foto"  height="300"></img>

    </AboutDiv>
  );
}
export default About;